import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  Paper,
  Divider,
  Fade,
  Chip,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import parasorc from '../../Assets/Homeimg/parasorc.png';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useGetArticals } from '../../Hooks/blogHooks.js';

const ViewNews = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { data: articals } = useGetArticals();

  const sectionTitle = (text) => (
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        mb: 1,
        color: '#072032',
        borderLeft: '4px solid #007FFF',
        pl: 1.5,
      }}
    >
      {text}
    </Typography>
  );

  return (
    <Fade in timeout={600}>
      <Box
        sx={{
          maxWidth: '960px',
          mx: 'auto',
          my: 4,
          px: 2,
        }}
      >
        {/* Header */}
        <Paper
          elevation={3}
          sx={{
            p: 3,
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #e3f2fd, #ffffff)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <ArrowBackIcon
              onClick={() => navigate(-1)}
              sx={{
                color: '#007FFF',
                fontSize: 30,
                cursor: 'pointer',
                transition: '0.3s ease',
                '&:hover': { transform: 'scale(1.1)', color: '#004f95' },
              }}
            />
            <Box
              component="img"
              src={parasorc}
              alt="Parasors Logo"
              sx={{ maxWidth: '160px', height: 'auto' }}
            />
          </Box>

          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: '#0a192f',
                mb: 2,
                textShadow: '1px 1px rgba(0,0,0,0.05)',
              }}
            >
              {location?.state?.title}
            </Typography>
            <Chip label="Legal News" variant="outlined" sx={{ mb: 1 }} />
          </Box>
        </Paper>

        {/* Body */}
        <Box
          sx={{
            mt: 5,
            background: '#ffffff',
            p: 4,
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          }}
        >
          {/* Overview */}
          {sectionTitle('Overview')}
          <Typography
            variant="body1"
            sx={{
              textAlign: 'justify',
              lineHeight: 1.8,
              color: 'text.secondary',
              mb: 4,
            }}
          >
            {location?.state?.overView?.replace(/<\/?[^>]+(>|$)/g, '')}
          </Typography>

          {/* Analysis */}
          {sectionTitle('Analysis')}
          <Typography
            variant="body1"
            sx={{
              textAlign: 'justify',
              lineHeight: 1.8,
              color: 'text.secondary',
              mb: 4,
            }}
          >
            {location?.state?.analysis?.replace(/<\/?[^>]+(>|$)/g, '')}
          </Typography>

          {/* Key Insights */}
          {sectionTitle('Key Insights')}
          <List sx={{ pl: 3, mb: 2 }}>
            {location?.state?.keyInsights?.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  display: 'list-item',
                  mb: 1.5,
                  color: 'text.primary',
                  fontSize: '16px',
                  fontWeight: 400,
                  '&::marker': {
                    color: '#007FFF',
                    fontSize: '1.2em',
                  },
                }}
              >
                {item?.title?.replace(/<\/?[^>]+(>|$)/g, '')}
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Fade>
  );
};

export default ViewNews;
